import { render } from "./IconFavoriteOfficeSchool.vue?vue&type=template&id=522dfb7a"
const script = {}

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__